import type { UiColor } from "simplydo/react/ui/utils/colors";

import { ROLE_ICON_NAMES, type RoleIconName } from "../roleIcons";

export const ROLE_EDITOR_ICON_OPTIONS: RoleIconName[] = ROLE_ICON_NAMES;

export const ROLE_EDITOR_COLOR_OPTIONS: UiColor[] = [
  "red",
  "orange",
  "yellow",
  "olive",
  "green",
  "teal",
  "blue",
  "violet",
  "purple",
  "pink",
];
